import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/content-managements', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/content-managements/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/content-managements', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/content-managements/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const uploadImage = data => {
  return httpClient
    .post('/api/content-managements/upload-files', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getContentType = (Options = {}) => {
    return httpClient
        .get('/api/content-types')
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))   
}

export const status = (id, data) => {
    return httpClient
        .put(`/api/content-managements/status-change/${id}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))   
}

export default { get, find, store, update, status, uploadImage, getContentType }
